<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>{{$t('updateUser.manage')}}</el-breadcrumb-item>
      <el-breadcrumb-item>{{$t('updateUser.updateUser')}}</el-breadcrumb-item>
    </el-breadcrumb>
    <h2>{{ accountInfo.companyName }}</h2>
    <el-card class="box-card" shadow="never">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-user"></i>&nbsp;{{$t('addUser.account')}}</span>
      </div>
      <el-form ref="form" :model="form" label-width="100px" :rules="rules">
        <el-form-item :label="$t('addUser.contactor')" prop="contactor">
          <el-input v-model="form.contactor" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item :label="$t('addUser.password')" prop="password">
          <el-input v-model="form.password" maxlength="20" placeholder="需要更新密码时请填写" show-password></el-input>
        </el-form-item>
        <el-form-item :label="$t('addUser.role')" prop="role">
          <el-radio v-model="form.role" label="A">{{$t('addUser.A')}}</el-radio>
          <el-radio v-model="form.role" label="B">{{$t('addUser.B')}}</el-radio>
          <el-radio v-model="form.role" label="C">{{$t('addUser.C')}}</el-radio>
          <el-radio v-model="form.role" label="T">{{$t('addUser.T')}}</el-radio>
        </el-form-item>
        <el-form-item :label="$t('addUser.group')" prop="groupID">
          <el-select v-model="form.groupID" style="width: 70%;" multiple>
            <el-option
              v-for="item in groupList"
              v-bind:key="item.groupID"
              v-bind:label="item.groupName"
              v-bind:value="item.groupID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('addUser.mobile')" prop="mobile">
          <el-input v-model="form.mobile" maxlength="11"></el-input>
        </el-form-item>
        <el-form-item :label="$t('addUser.mail1')" prop="mail1">
          <el-input v-model="form.mail1" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item :label="$t('addUser.systemmail')" prop="systemmail">
          <el-radio v-model="form.systemmail" label="1">{{$t('addUser.notice')}}</el-radio>
          <el-radio v-model="form.systemmail" label="0">{{$t('addUser.notnotice')}}</el-radio>
        </el-form-item>
        <el-form-item :label="$t('addUser.billmail')" prop="billmail">
          <el-radio v-model="form.billmail" label="1">{{$t('addUser.notice')}}</el-radio>
          <el-radio v-model="form.billmail" label="0">{{$t('addUser.notnotice')}}</el-radio>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('form')">{{$t('updateUser.update')}}</el-button>
          <el-button @click="resetForm()">{{$t('addUser.back')}}</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { updateUser,userDetail,listGroup } from "@/api/admin";
import { mapState } from "vuex";
import { ROUTER_PATH } from "@/constants/common.js";
export default {
  name: "UpdateUser",
  data() {
    
    return {
      backupInfo: { companyName: "", restInPlan: [] },
      groupList: [],
      form: {
        contactor: "",
        mobile: "",
        mail1:"",
        role:"",
        systemmail:"",
        billmail:"",
        password:""
      },
      rules: {
        contactor: [
          { required: true, message: "请输入联系人", trigger: "blur" },
          { min: 1, max: 20, message: "长度在 1 到 20 个字符", trigger: "blur" }
        ],
        mobile: [
          { required: true, message: "请输入联系人手机", trigger: "blur" },
          { min: 11, max: 11, message: "手机长度需是11位", trigger: "blur" }
        ],
        mail1: [
          { required: true, message: "请输入联系邮件", trigger: "blur" },
          { min: 6, max: 50, message: "请输入正确的邮件地址", trigger: "blur" }
        ]
      }
    };
  },
  mounted() {
    listGroup({
      companyID: this.accountInfo.companyID
    }).then((response) => {
      this.groupList = response.data.items;
      this.refreshData();
    });
    
  },
  computed: {
    ...mapState(["accountInfo"])
  },
  methods: {
    
    refreshData() {
      userDetail({
        userID: this.$route.query.id
      }).then(response => {
        this.form = { ...response.data };
        this.form.systemmail = response.data.systemmail.toString();
        this.form.billmail = response.data.billmail.toString();
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          updateUser({
            userID: this.accountInfo.userID,
            targetUserID: this.$route.query.id,
            ...this.form
          }).then(response => {
            this.$message({
              message: response.message,
              type: "success"
            });
            this.$router.push(ROUTER_PATH.ADMIN_USER);
          });
        } else {
          return false;
        }
      });
    },
    resetForm() {
      this.$router.push(ROUTER_PATH.ADMIN_USER);
    }
  }
};
</script>
